<template>
  <v-container>
    <h2>Update admin</h2>
    <v-row>
      <v-col lg="10" md="12" sm="12">
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="user.firstname"
              label="Firstname"
              :rules="[rules.require]"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="user.lastname"
              label="Lastname"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="user.username"
              label="Username"
              :rules="[rules.require]"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="user.email"
              label="Email"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="user.phone_number"
              label="Phone number"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="user.line_id"
              label="Line ID"
              outlined
              dense
            />
          </v-col>
          <v-col
            v-if="user.role != 'Super Admin'"
            cols="12"
            md="6"
          >
            <v-select
              :items="role_list"
              item-text="label"
              item-value="value"
              label="Role"
              v-model="user.role_id"
              outlined
              dense
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-switch
              v-model="user.active"
              label="Active"
              inset
              color="orange"
            ></v-switch>
          </v-col>
        </v-row>
        <v-btn
          small
          text
          color="primary"
          :to="{ name: 'user-edit-password' }"
        >
          Update password
        </v-btn>
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            color="orange"
            dark
            @click="updateUser"
          >
            Update
          </v-btn>
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'user-list' }"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "UserEdit",
  components: { },
  data: () => ({
    user: {
      id: null,
      firstname: null,
      lastname: null,
      username: null,
      email: null,
      phone_number: null,
      line_id: null,
      role_id: null
    },
    role_list: [ ],
    rules: {
      profile_image: value => !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!',
      require: value => !!value || 'Please fill in information'
    },
  }),
  async mounted () {
    this.user.id = this.$route.params.id
    await this.getRoleList()
    await this.getUser()
  },
  methods: {
    async getUser () {
      try {
        const { data } = await this.$http.get(`/back-office/admins/${this.user.id}`, authHeader())
        this.user.firstname = data.firstname
        this.user.lastname = data.lastname
        this.user.email = data.email
        this.user.username = data.username
        this.user.phone_number = data.phone_number
        this.user.line_id = data.line_id
        this.user.role_id = data.role_id
        this.user.active = data.active
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    async updateUser () {
      try {
        if (this.requireField()) {
          await this.$http.put(`/back-office/admins/${this.user.id}`, this.user, authHeader())
          this.$router.push({ name: 'user-list'})
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    requireField () { 
      if (!this.user.firstname) {
        alert('Please fill in firstname')
        return false;
      } else if (!this.user.username) {
        alert('Please fill in username')
        return false;
      } else if (!this.user.role_id) {
        alert('Please select role')
        return false;
      }
      return true
    },
    async getRoleList () {
      const { data } = await this.$http.get('/back-office/roles', authHeader())
      data.forEach(item => {
        this.role_list.push({
          label: item.role_name,
          value: item.id
        })
      })
    },
  },
};
</script>
